import { asset } from "~/translations/products/asset";
import { useLanguage } from "~/hooks/useLanguage";
import type { Language } from "~/utils/language";
import { Modal, Button } from "~/components/ui";
import TrashDeleteIcon from "../icons/TrashDeleteIcon";

export enum deletionTypes {
  PRODUCT = "product",
  ROW = "row",
  OPENFINANCE_PRODUCT = "openfinanceProduct",
  OPENFINANCE_CONNECTION = "openfinanceConnection",
  FAMILY_MEMBER = "familyMember",
  TRASNACTION_RULE = "transactionRule",
}

const deletionTypeToText = (
  deletionType: string,
  productName: string,
  lang: Language
) => {
  switch (deletionType) {
    case deletionTypes.PRODUCT:
      return `${asset[lang].deleteProduct} “${productName}“?`;
    case deletionTypes.ROW:
      return asset[lang].deleteRow;
    case deletionTypes.OPENFINANCE_PRODUCT:
      return asset[lang].deleteOpenFinanceProduct;
    case deletionTypes.OPENFINANCE_CONNECTION:
      return `${asset[lang].deleteOpenFinanceConnection1} “${productName}“? ${asset[lang].deleteOpenFinanceConnection2}`;
    case deletionTypes.FAMILY_MEMBER:
      return `${asset[lang].family_member_delete1} “${productName}“? ${asset[lang].family_member_delete2}`;
    case deletionTypes.TRASNACTION_RULE:
      return `${asset[lang].transaction_rule_delete1} “${productName}“? ${asset[lang].transaction_rule_delete2}`;
    default:
      return asset[lang].delete;
  }
};

type Props = {
  productName?: string;
  deleteProduct: () => void;
  close: () => void;
  deletionType: string;
  isDeletingRow?: boolean;
  isOpenFinance?: boolean;
};

const DeleteConfirmationModal = ({
  productName,
  deleteProduct,
  close,
  deletionType,
  isDeletingRow = false,
  isOpenFinance = false,
}: Props) => {
  const { lang } = useLanguage();
  let deleteText = deletionTypeToText(deletionType, productName || "", lang);
  return (
    <Modal
      open={true}
      onClose={close}
      size="md"
      footer={
        <>
          <Button variant="ghost" onClick={close}>
            {asset[lang].cancel}
          </Button>
          <Button variant="danger" onClick={deleteProduct}>
            {isDeletingRow ? asset[lang].yes : asset[lang].delete}
          </Button>
        </>
      }
    >
      <div className="flex flex-col items-center">
        {!isDeletingRow && <TrashDeleteIcon />}
        <div className="mt-5 whitespace-pre-line break-words px-2 text-center text-xl font-bold mobile:text-[20px]">
          {deleteText}
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
